import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import {
  makeStyles,
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Grid,
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";

import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingTop: 74,
    paddingBottom: 74,
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  qrImageRoot: {
    position: "relative",
    height: "100%",
  },
  qrImageCover: {
    zIndex: 1,
    height: "inherit",
  },
  MuiCardActionArea: {
    height: "inherit",
    zIndex: 1,
  },
}));

function srcset(image: string, size: number, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${size *
      rows}&fit=crop&auto=format&dpr=2 2x`,
  };
}

const QRCodeGallery = ({ className, ...rest }) => {
  useEffect(() => {}, []);
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div id="api-catalogue">
      <Container maxWidth="lg">
          <Typography variant="h2" align="center" style={{ color: "#5850EC" }}>
          Artistic QRCodes Generated By Customers Today!
          </Typography>
          <Box mt={8}>
            <Grid container spacing={4}>
             
                {itemData.map((item) => (
                    <Grid item xs={12} md={3}>
                      <Card className={classes.qrImageRoot}>
                        <CardActionArea
                          component={RouterLink}
                          to={{ pathname: "https://ai.qrcodes.apitier.com/login" }}
                          target="_blank"
                        >
                          <CardContent>
                            <Box
                              display="flex"
                              alignItems="center"
                              flexDirection="column"
                              textAlign="center"
                              justifyContent="center"
                            >
                              <CardMedia
                                component="img"
                                classes={{ root: classes.qrImageCover }}
                                image={`${item.img}?w=248&fit=crop&auto=format`}
                                title={item.title}
                              />

                              <Typography
                                variant="h5"
                                gutterBottom
                                color="textPrimary"
                              >
                                {item.title}
                              </Typography>
                            </Box>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Grid>
                ))}
            </Grid>
          </Box>
        </Container>
      </div>
    </div>
  );
};

QRCodeGallery.propTypes = {
  className: PropTypes.string,
};

const itemData = [
  {
    img: "/static/qrcodes/The_Eiffel_Tower_Paris_France.png",
    title: "Eiffel Tower Paris",
  },
  {
    img: "/static/qrcodes/Big_Ben_London_england.png",
    title: "Big Ben London",
  },
  {
    img: "/static/qrcodes/coca_cola_christmas_advertisment.png",
    title: "Coca Cola",
  },
  {
    img: "/static/qrcodes/Verona_Italy_city_view.png",
    title: "Verona Italy City",
  },
  {
    img: "/static/qrcodes/Mount_Everest_as_QR_Code.png",
    title: "Mount Everest",
  },
  {
    img: "/static/qrcodes/red_bmw_x7.png",
    title: "Red BMW X7",
  },
  {
    img: "/static/qrcodes/Rome_City_View.png",
    title: "Rome City View",
  },
  {
    img: "/static/qrcodes/Solar_System_as_QR_Code.png",
    title: "Solar System",
  },
  {
    img: "/static/qrcodes/Lego_family_as_QR_Code.png",
    title: "Lego Family",
  },
  {
    img: "/static/qrcodes/edinburgh_city_view.png",
    title: "Edinburgh City",
  },
  {
    img:
      "/static/qrcodes/View_of_the_Swiss_Alps_near_the_city_of_Lauterbrunnen..png",
    title: "Swiss Alps at Lauterbrunnen",
  },
  {
    img: "/static/qrcodes/Zurich_Switzerland_city_view.png",
    title: "Zurich Switzerland",
  },
];
export default QRCodeGallery;
